export default __webpack_public_path__ + "static/media/like.bf548d72.svg";